import { HOME_SECTIONS, normalizeSections } from "@/lib/homeSections";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { ArrowUp, ArrowDown, GripVertical, RotateCcw } from "lucide-react";

export const HomeSectionsEditor = ({ value, onChange }) => {
  const list = normalizeSections(value);
  const move = (i, d) => { const n = [...list]; const j = i + d; if (j < 0 || j >= n.length) return; [n[i], n[j]] = [n[j], n[i]]; onChange(n); };
  const toggle = (i) => { const n = list.map((s, k) => (k === i ? { ...s, visible: !s.visible } : s)); onChange(n); };
  return (
    <div className="space-y-3 border-t pt-6" data-testid="home-sections-editor">
      <div className="flex items-center justify-between">
        <div><h3 className="font-heading text-xl">Home page sections</h3><p className="text-xs text-muted-foreground">Reorder with the arrows and hide sections you don't need. The hero always stays on top.</p></div>
        <Button type="button" variant="ghost" size="sm" className="rounded-full" onClick={() => onChange(HOME_SECTIONS.map((s) => ({ key: s.key, visible: true })))} data-testid="sections-reset"><RotateCcw className="h-3.5 w-3.5 mr-1" /> Reset</Button>
      </div>
      <ol className="rounded-xl border divide-y bg-card">
        {list.map((s, i) => (
          <li key={s.key} className={`flex items-center gap-3 px-3 py-2 ${s.visible ? "" : "opacity-50"}`} data-testid={`section-row-${s.key}`}>
            <GripVertical className="h-4 w-4 text-muted-foreground" />
            <span className="w-6 text-xs text-muted-foreground font-mono">{i + 1}</span>
            <span className="flex-1 text-sm font-medium">{HOME_SECTIONS.find((d) => d.key === s.key)?.label}</span>
            <Button type="button" variant="ghost" size="icon" className="h-7 w-7" disabled={i === 0} onClick={() => move(i, -1)} data-testid={`section-up-${s.key}`}><ArrowUp className="h-3.5 w-3.5" /></Button>
            <Button type="button" variant="ghost" size="icon" className="h-7 w-7" disabled={i === list.length - 1} onClick={() => move(i, 1)} data-testid={`section-down-${s.key}`}><ArrowDown className="h-3.5 w-3.5" /></Button>
            <Switch checked={s.visible} onCheckedChange={() => toggle(i)} data-testid={`section-visible-${s.key}`} />
          </li>
        ))}
      </ol>
    </div>
  );
};
